import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from '@shared/lib/hooks';
import { AuthContext } from './AuthContext';
import { AdminRole, MemberRole, TrainerRole, UserCredentials } from '../types';

export const useAuth = () => {
  const auth = useContext(AuthContext);
  if (!auth) {
    throw new Error('useAuthContext can only be used within a Provider');
  }
  const { user, setUser, loading } = auth;
  const { setItem } = useLocalStorage();

  const login = (user: UserCredentials) => {
    //Set State in Context
    setUser(user);
    //Set in Local Storage
    setItem('user', JSON.stringify(user));
  };
  const logout = () => {
    setUser(null);
    setItem('user', '');
  };
  return { user, login, logout, loading };
};

//Use When you need to securely access nonNull value
export const useAuthenticatedUser = () => {
  const { user } = useAuth();
  if (!user) {
    throw new Error(
      'Use Authenticated User MUST be used within Protected Route Outlet'
    );
  }
  const isMember = (user: UserCredentials): user is MemberRole => {
    return user.role === 'member';
  };
  const isTrainer = (user: UserCredentials): user is TrainerRole => {
    return user.role === 'trainer';
  };

  const isAdmin = (user: UserCredentials): user is AdminRole => {
    return user.role === 'admin';
  };

  return { user, isMember, isTrainer, isAdmin };
};

export const useStaffNavigate = (user: UserCredentials, path: string) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (user.role !== 'member') {
      navigate(`../${user.role}/${path}`);
    }
  }, []);
};
